import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { findIndex } from "lodash";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { Box } from "@mui/system";
import { Button } from "@mui/material";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import { unicodeToString, hhmmssToMilli } from "../../../Js/Common";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";

import YouTube from "react-youtube";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "presentation",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 1,
};

const MEDIA = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const video = useRef(null);

  const opts = {
    height: "390",
    width: "640",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
    },
  };

  const [videoUrl, setVideoUrl] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [tracks, setTracks] = useState([]);
  const [millisecondsToPause, setMillisecondsToPause] = useState([]);
  const [cueCount, setCueCount] = useState(0);
  const [initialPosition, setInitialPosition] = useState(0);
  const [logObj, setLogObj] = useState(initLogObj);
  const [currentVideoUrlIndex, setCurrentVideoUrlIndex] = useState(0);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt } = useSelector(
    (state) => state.currentAsset
  );

  const classes = useStyles();
  useEffect(() => {
    if (props.content) {
      setTracks([]);
      setMillisecondsToPause([]);
      setCueCount(-1);
      console.log(
        "::::::",
        `${sessionStorage.getItem("media_url")}video/${
          props.content.epage.instruction.media.video
        }`
      );
      setVideoUrl(
        `${sessionStorage.getItem("media_url")}video/${
          props.content.epage.instruction.media.video
        }`
      );
      if (
        props.content &&
        props.content.epage &&
        props.content.epage.preference
      ) {
        setTracks(props.content.epage.preference.tracks);
        if (
          Array.isArray(props.content.epage.preference.tracks) &&
          props.content.epage.preference.tracks.length > 0
        ) {
          let milliseconds = props.content.epage.preference.tracks[0][
            "cues"
          ].map((val, index) => {
            return {
              ...val,
              start: hhmmssToMilli(val.start),
            };
          });
          //console.log("milliseconds",milliseconds);
          setMillisecondsToPause(milliseconds);
          setCueCount(0);
          setInitialPosition(0);
        }
      }
      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: "",
      });
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
  }, [logObj]);

  const timeUpdate = (ev) => {
    let positionMillis = +ev.target.currentTime * 1000;
    updateCueCount(positionMillis);
    if (
      video.current &&
      cueCount != -1 &&
      cueCount < millisecondsToPause.length &&
      +positionMillis >= +millisecondsToPause[cueCount]["start"]
    ) {
      //console.log("%%&&&&111",video.current);
      video.current.pause();
    }
  };

  const updateCueCount = (currentMillis) => {
    let index = findIndex(millisecondsToPause, (o) => {
      return o.start >= currentMillis;
    });
    if (index >= 0) {
      setCueCount(index);
    } else {
      setCueCount(-1);
    }
  };

  const seekTo = async (flag) => {
    if (flag == "next" && cueCount < millisecondsToPause.length) {
      await video.current.setPositionAsync(
        millisecondsToPause[cueCount]["start"]
      );
    }
    if (flag == "prev" && cueCount > 1) {
      await video.current.setPositionAsync(
        millisecondsToPause[cueCount - 2]["start"]
      );
    }
    if (flag == "prev" && cueCount == 1) {
      await video.current.setPositionAsync(millisecondsToPause[0]["start"]);
    }
  };

  return (
    <Box
      sx={{
        mx: 6,
        height: "55vh",
      }}
    >
      <Grid
        container
         
        sx={{
          flexDirection: "row",
          flexFlow: "wrap",
          justifyContent: "center",
          height: "69.5vh",
          alignItems: "center",
          overflow: "auto",
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            textAlign: "center",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Card sx={{ boxShadow: 0 }}>
            <CardMedia>
              {!props.content?.epage?.options?.outside_src && (
                <video
                  ref={video}
                  width="70%"
                  controls
                  disablepictureinpicture
                  controlslist="nodownload noplaybackrate"
                  style={{ borderRadius: "20px 20px 0px 0px" }}
                  onTimeUpdate={timeUpdate}
                  onEnded={() => {
                    setIsFinished(true);
                    setCueCount(0);
                  }}
                  src={videoUrl}
                  poster={
                    props.content?.epage?.preference?.poster
                      ? `${sessionStorage.getItem("media_url")}image/${
                          props.content.epage.preference.poster
                        }`
                      : null
                  }
                ></video>
              )}
              {props.content?.epage?.options?.outside_src && (
                <Grid container>
                  <Grid xs={2}   sx={{height: "65vh", overflow: "auto", paddingX: 2}}>
                    {props.content?.epage?.options?.content &&
                      props.content?.epage?.options?.content.map(
                        (val, index) => {
                          return (
                            <Button
                              variant="contained"
                              fullWidth
                              key={`${index}_btn`}
                              sx={{
                                marginTop: index > 0 ? 2 : 0,
                                backgroundColor:
                                  currentVideoUrlIndex == index
                                    ? "#DB8829"
                                    : "#EEEEEE",
                                color:
                                  currentVideoUrlIndex == index
                                    ? "#FFFFFF"
                                    : "#DB8829",
                              
                              }}
                              onClick={() => {
                                setCurrentVideoUrlIndex(index);
                              }}
                            >
                              {unicodeToString(val.text)}
                            </Button>
                          );
                        }
                      )}
                  </Grid>
                  <Grid xs={10}>
                    <YouTube
                      videoId={unicodeToString(
                        props.content?.epage?.options?.content[
                          currentVideoUrlIndex
                        ]["video_id"]
                      )}
                      opts={opts}
                    />
                  </Grid>
                </Grid>
              )}
            </CardMedia>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default MEDIA;
